import { isNullOrUndefined } from 'utils/Global';
import IngredientProbabilityRange from './IngredientProbabilityRange';
import {
  RandomLayerGroupIngredientDTO,
  RandomLayerIngredientGroupDTO,
} from './models/Models';

export default class RandomIngredientPicker {
  public groupIngredients: RandomLayerGroupIngredientDTO[] = [];

  public GetIngredient(): RandomLayerGroupIngredientDTO[] {
    return this.groupIngredients;
  }
  public constructor(groupRow: RandomLayerIngredientGroupDTO) {
    groupRow.randomLayerGroupIngredient.forEach((ingredientRow) => {
      this.groupIngredients.push(ingredientRow);
    });
  }
  public RemoveIngredient(ingredientRow) {
    this.groupIngredients.splice(ingredientRow, 1);
  }

  public RandomIngredient(): RandomLayerGroupIngredientDTO {
    // Compute sum of the weights of all ingredients in group
    let totalWeight = 0;
    this.groupIngredients.forEach((ingredientRow) => {
      totalWeight += ingredientRow.weight;
    });
    // Compute normalized (between 0 and 1) probabilities of each ingredient in group.
    const ingredientProbabilities: IngredientProbabilityRange[] = [];
    let totalProbability = 0;
    this.groupIngredients.forEach((ingredientRow) => {
      const probability = ingredientRow.weight / totalWeight;
      ingredientProbabilities.push(
        new IngredientProbabilityRange(
          ingredientRow,
          totalProbability,
          totalProbability + probability,
        ),
      );
      totalProbability += probability;
    });

    // Pick a random number.
    const randomNumber = Math.random();

    // Return the ingredient whose range satisfies the random number.
    let ing: RandomLayerGroupIngredientDTO;
    ingredientProbabilities.forEach((range) => {
      if (range.IsInRange(randomNumber)) {
        ing = range.GetIngredient();
        return ing;
      }
    });
    // Something went wrong - random number didn't fall into range of any of the ingredients.
    // This should never happen.
    if (isNullOrUndefined(ing)) {
      throw new Error('Something went wrong!');
    }
    return ing;
  }
}
